import React from "react";

const Avatar = ({row}) => {

    if (row.first_letter) {
        return <span className="avatar-letter">
                    <span style={{
                        backgroundColor: row.color.backgroundColor,
                        color: row.color.color
                    }}>{row.first_letter}</span>
                </span>
    } else {
        return <img src={row.avatar} alt="avatar"/>
    }
}

export default Avatar;